export default [
    {
        path: 'relatorio-atendimento',
        component: () => import(/* webpackChunkName: 'pronto-atendimento-relatorio-atendimento' */ '@/views/pronto-atendimento/relatorio-atendimento/Index'),
        redirect: 'relatorio-atendimento/index',
        children: [
            {
                name: 'bpa-relatorio-atendimento-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'pronto-atendimento-relatorio-atendimento' */ '@/views/pronto-atendimento/relatorio-atendimento/List.vue'),
            },
        ],
    },
]